import { put } from "redux-saga/effects";

import { ApiCaller, Utils } from "../../config";
import { ArtistAction } from "../actions";

export default class ArtistMiddleware {
    static *GetArtistListing({ payload, cb }) {
        try {
            const {
                limit = 10,
                offset = 0,
                keyword = "",
                status = "",
                role_name = ""
            } = payload;
            let res = yield ApiCaller.Get(
                `/users?offset=${offset}&keyword=${keyword}&limit=${limit}&status=${status}&role_name=${role_name}`
            );
            if (res.status == 200) {
                yield put(ArtistAction.getArtistListingSuccess(res.data.data));

                if (cb) {
                    cb();
                }
            } else {
                yield put(ArtistAction.getArtistListingFailure(res.data.message));
                Utils.showSnackBar({
                    message: res.data.message,
                    severity: "error",
                });
            }
        } catch (err) {
            yield put(ArtistAction.getArtistListingFailure());
            //   Utils.showSnackBar({
            //     message: "Reset password failed",
            //     severity: "error",
            //   });
        }
    }

    static *ChangeArtistStatus({ id, cb }) {
        try {
            let res = yield ApiCaller.Put(`/users/status/toggle?user_id=${id}`);
            if (res.status == 201) {
                yield put(ArtistAction.changeArtistStatusSuccess(res.data.data));
                Utils.showSnackBar({
                    message: res.data.message,
                });
                if (cb) {
                    cb();
                }
            } else {
                yield put(ArtistAction.changeArtistStatusFailure(res.data.message));
                Utils.showSnackBar({
                    message: res.data.message,
                    severity: "error",
                });
            }
        } catch (err) {
            yield put(yield put(ArtistAction.changeArtistStatusFailure()));
        }
    }

    static *DeleteArtist({ id, cb }) {
        try {
            let res = yield ApiCaller.Delete(`/user/delete?user_id=${id}`);
            if (res.status == 200) {
                yield put(ArtistAction.deleteArtistSuccess(res.data.data));
                Utils.showSnackBar({
                    message: res.data.message,
                });
                if (cb) {
                    cb();
                }
            } else {
                yield put(ArtistAction.deleteArtistFailure(res.data.message));
                Utils.showSnackBar({
                    message: res.data.message,
                    severity: "error",
                });
            }
        } catch (err) {
            yield put(yield put(ArtistAction.deleteArtistFailure()));
        }
    }

    static *AddEmail({ data, cb }) {
        try {

            let res = yield ApiCaller.Post(`/user/email`, data);
            if (res.status == 200) {
                yield put(ArtistAction.addEmailSuccess(res.data.data));
                Utils.showSnackBar({
                    message: res.data.message,
                });
                if (cb) {
                    cb(res);
                }
            } else {
                yield put(ArtistAction.addEmailFailure(res.data.message));
                Utils.showSnackBar({
                    message: res.data.message,
                    severity: "error",
                });
            }
        } catch (err) {
            yield put(yield put(ArtistAction.addEmailFailure()));
        }
    }


    static *ApproveArtist({ data, cb }) {
        try {
            const { id, status } = data

            let res = yield ApiCaller.Put(`/artist/${id}/approve`, { approve:status });
            if (res.status == 201) {
                yield put(ArtistAction.approveArtistSuccess(res.data.data));
                Utils.showSnackBar({
                    message: res.data.message,
                });
                if (cb) {
                    cb(res);
                }
            } else {
                yield put(ArtistAction.approveArtistFailure(res.data.message));
                Utils.showSnackBar({
                    message: res.data.message,
                    severity: "error",
                });
            }
        } catch (err) {
            yield put(yield put(ArtistAction.approveArtistFailure()));
        }
    }

}
